define('taoQtiItem/qtiXmlRenderer/renderers/Math',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'math',
        template : tpl
    };
});
